import image1 from "../../../assets/images/mignardises/IMG_2024.JPG"
import image2 from "../../../assets/images/mignardises/IMG_2025.JPG"
import image3 from "../../../assets/images/mignardises/IMG_2026.JPG"
import image4 from "../../../assets/images/mignardises/IMG_2027.JPG"
import image5 from "../../../assets/images/mignardises/IMG_2028.JPG"
import image6 from "../../../assets/images/mignardises/IMG_2029.JPG"
import image7 from "../../../assets/images/mignardises/IMG_2030.JPG"
import image8 from "../../../assets/images/mignardises/IMG_2031.JPG"






export const mignardisesImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
]

